<script setup>

</script>

<template>
    <div class="login-footer">
        <div>9253 Eton Avenue, Chatsworth, CA 91311</div>
	    <div>Tel:(818) 877-9929</div>
	    <div>info@fantastictheaters.com</div>
    </div>
</template>

<style scoped lang="scss">

.login-footer{
    @apply flex flex-wrap gap-x-[20px] justify-center items-center
    h-[65px] bg-[#5B0D0F] text-white font-medium text-center
    text-[13px] md:text-[14px];
}


</style>
